// useAuth.js
import { useSelector } from 'react-redux';
import { selectAuthUser } from '../store/slices/authSlice';

export default function useAuth() {
  const user = useSelector(selectAuthUser);
  return { user };
}
